<template>
  <f7-page>
    <f7-navbar :no-shadow="true">
      <f7-nav-left>
        <a class="link color-theme-white popup-close" href="#">
          <i class="icon icon-back"></i>
          <span>返回</span>
        </a>
      </f7-nav-left>
      <f7-nav-title>{{ title }}</f7-nav-title>
      <f7-nav-right>
        <f7-link @click="save">保存</f7-link>
      </f7-nav-right>
    </f7-navbar>
    <div class="has-content">
      <f7-block>
        <div class="approve-result">
          <div class="approve-result-item" :key="item.code" v-for="item in approveOperateList">
            <f7-radio
              color="orange"
              :name="item.name"
              :value="item.code"
              :checked="acceptance.result === item.code"
              @change="acceptance.result = $event.target.value"
            ></f7-radio>
            &nbsp;
            <span>{{ item.name }}</span>
          </div>
        </div>
        <div class="approve-comments">
          <f7-list inline-labels id="approveForm">
            <f7-list-input
              type="textarea"
              :value="acceptance.remark"
              @input="acceptance.remark = $event.target.value"
              placeholder="请填写验收情况说明"
              required
              validate
              minlength=2
              maxlength=500
              error-message="必填项，2-500个字符"
              inputStyle="text-align: left; padding-top: 0rem;"
              style="width: 100%; height: 100%;"
              resizable>
            </f7-list-input>
          </f7-list>
        </div>
        <!-- <div @click="browserPhoto(project.attachmentList)">
          <f7-swiper :params="{speed:500, slidesPerView: 4, spaceBetween: 10,
            observer: true, observeParents: true}">
            <f7-swiper-slide  v-for="attach in project.attachmentList" :key="attach">
              <img :src="imageUrl+'?attachmentId='+attach" style="width: 100%; height: 100%;"/>
            </f7-swiper-slide>
          </f7-swiper>
        </div> -->
        <div class="approve-score" v-if="label">
          <div>{{ label }}：</div>
          <div
            class="approve-score-star"
            v-for="item in scoreList"
            :key="item"
            @click="acceptance.star = item">
            <f7-icon
              size="1.2rem"
              color="yellow"
              :fa="item <= acceptance.star ? 'star' : 'star-o'">
            </f7-icon>
          </div>
        </div>
        <div class="approve-score" v-if="projectAcceptanceItem === 'composite'">
          <div>任务进度：</div>
          <div
            class="approve-score-star"
            v-for="item in scoreList"
            :key="item"
            @click="acceptance.progressStar = item">
            <f7-icon
              size="1.2rem"
              color="yellow"
              :fa="item <= acceptance.progressStar ? 'star' : 'star-o'">
            </f7-icon>
          </div>
        </div>
      </f7-block>
      <div class="img-show-area">
        <div class="img-show" v-for="file in files" :key="file.id">
          <img v-if="file.thumb" :src="file.thumb" width="100%" height="100%" />
          <span v-else>无图片</span>
          <div class="img-show-close" @click="removeFile(file)">
            <f7-icon fa="times" size="1rem"></f7-icon>
          </div>
        </div>
        <div class="img-show">
          <file-upload
            class="file-upload"
            input-id="approveFile"
            :post-action="uploadURL"
            :extensions="extensions"
            :accept="accept"
            :multiple="multiple"
            :size="size || 0"
            :thread="thread < 1 ? 1 : (thread > 5 ? 5 : thread)"
            :add-index="addIndex"
            v-model="files"
            @input-filter="inputFilter"
            ref="approveUpload">
            <f7-icon fa="plus" size="1rem"></f7-icon>
          </file-upload>
        </div>
        <div
          class="img-show"
          v-if="(files.length + 1) % 3 > 0 && (files.length + 1) % 3 <= 1">
        </div>
        <div
          class="img-show"
          v-if="(files.length + 1) % 3 > 0 && (files.length + 1) % 3 <= 2">
        </div>
      </div>
    </div>
  </f7-page>
</template>
<script>
import lodash from 'lodash';
import { getDict, imageView, uploadFileUrl } from '@/api/common';
import { approveAcceptance } from '@/api/acceptance';
import { createToast } from '@/util/compUtils';
import { Acceptance } from '@/model/reqObject';
import FileUpload from 'vue-upload-component';

export default {
  props: ['project', 'projectId', 'title', 'projectAcceptanceItem', 'label', 'opened'],
  components: {
    FileUpload,
  },
  data() {
    return {
      imageUrl: imageView,
      approveOperateList: [],
      scoreList: [1, 2, 3, 4, 5],
      acceptance: new Acceptance({ projectId: this.projectId }),
      files: [],
      accept: 'image/png,image/gif,image/jpeg,image/webp',
      extensions: 'gif,jpg,jpeg,png,webp',
      minSize: 1024,
      size: 1024 * 1024 * 10,
      multiple: true,
      addIndex: false,
      thread: 3,
      name: 'file',
      uploadURL: uploadFileUrl,
      flag: true,
      watchFun: null,
    };
  },
  mounted() {
    const dictKeys = ['approveOperate'];
    getDict({ typeCodes: dictKeys }).then((result) => {
      this.approveOperateList = result.data.approveOperate.codeVoList || [];
    });
  },
  watch: {
    opened(newVal) {
      if (this.watchFun) {
        this.watchFun();
        this.files = [];
      }
      if (newVal) {
        this.acceptance = new Acceptance({ projectId: this.projectId });
        this.watchFun = this.$watch(
          () => this.flag && this.files.length !== 0
            && this.$refs.approveUpload && this.$refs.approveUpload.uploaded,
          (val) => {
            if (val) {
              this.addObj();
            }
          },
        );
      }
    },
  },
  methods: {
    browserPhoto(itemArr) {
      this.$f7.photoBrowser.create({
        photos: (itemArr || []).map(item => `${this.imageUrl}?attachmentId=${item}`),
        backLinkText: '返回',
        navbarOfText: '/',
        iconsColor: 'white',
        routableModals: false,
      }).open();
    },
    save() {
      this.flag = false;
      // this.$f7.input.validateInputs('#approveForm');
      let valided = true;
      this.$$('#approveForm').find('input, textarea, select').forEach((inputEl) => {
        valided = valided && !this.$$(inputEl).hasClass('input-invalid');
      });
      if (!this.approveOperateList.find(item => item.code === this.acceptance.result)) {
        createToast(this, '请选择验收意见');
        valided = false;
      }
      if (valided &&
        (this.files.length === 0
          || (this.$refs.approveUpload && this.$refs.approveUpload.uploaded))) {
        this.addObj();
      } else if (valided && this.files.length > 0) {
        this.$f7.dialog.preloader('正在上传数据');
        this.$refs.approveUpload.active = true;
        this.flag = true;
      }
    },
    addObj() {
      let uploadValid = true;
      const fileIdList = [];
      this.files.forEach((file) => {
        uploadValid = uploadValid && (file.response.code === 0);
        if (file.response.code === 0) {
          fileIdList.push(file.response.data.id);
        }
      });
      if (uploadValid) {
        this.$set(this.acceptance, 'attachmentIdList', lodash.uniq(fileIdList));
        this.$set(this.acceptance, 'applyId', this.project.id);
        this.$set(this.acceptance, 'projectId', this.projectId);
        this.$set(this.acceptance, 'acceptanceItem', this.projectAcceptanceItem);
        approveAcceptance(this.acceptance).then((result) => {
          this.$f7.dialog.close();
          if (result.code === 0) {
            const msg = this.acceptance.result === 'agree' ? '验收成功' : '已通知整改';
            createToast(this, msg);
            this.$emit('update:opened', false);
          }
        });
      }
    },
    removeFile(oldFile) {
      if (this.files.includes(oldFile)) {
        this.files.splice(this.files.findIndex(item => item.id === oldFile.id), 1);
      }
    },
    inputFilter(newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        if (!/\.(jpeg|jpe|jpg|gif|png|webp)$/i.test(newFile.name)) {
          return prevent();
        }
      }
      if (newFile && (!oldFile || newFile.file !== oldFile.file)) {
        Object.assign(newFile, { blob: '' });
        const URL = window.URL || window.webkitURL;
        if (URL && URL.createObjectURL) {
          Object.assign(newFile, { blob: URL.createObjectURL(newFile.file) });
        }
        Object.assign(newFile, { thumb: '' });
        if (newFile.blob && newFile.type.substr(0, 6) === 'image/') {
          Object.assign(newFile, { thumb: newFile.blob });
        }
      }
      return true;
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '~@/style/app-var.scss';

  .approve-result {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0rem 5rem;
  }

  .approve-result-item {
    display: flex;
    align-items: center;
  }

  .approve-comments {
    margin: 1rem 0rem;
    padding: 0rem 0.5rem;
    border: 0.05rem solid $border-color;
    border-radius: 0.3rem;
  }

  .approve-score {
    display: flex;
    margin: 2rem 0rem;
  }

  .approve-score-star {
    cursor: pointer;
    padding: 0rem 0.25rem;
  }

  .img-show-area {
    border-top: 0.05rem solid $border-color;
    text-align: center;
    padding: 1rem 0rem;
    display: flex;
    flex-flow:row wrap;
    align-items: flex-start;
    justify-content: space-around;
  }

  .img-show {
    width: 30%;
    height: 6rem;
    padding: 0.5rem 0rem;
    position: relative;
  }

  .img-show-close {
    color: $white-color;
    height: 1rem;
    width: 1rem;
    line-height: 1rem;
    position: absolute;
    right: 0rem;
    top: 0.5rem;
    text-align: center;
    background-color: $theme-color;
    cursor: pointer;
  }

  .file-upload {
    background-color: $panel-bg-color;
    border-radius: 0.5rem;
    width: 100%;
    height: 100%;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
  }

</style>



// WEBPACK FOOTER //
// src/pages/acceptance/approve.vue